import React, { useState } from "react";
import { Badge, Row, Col } from "react-bootstrap";
import { CommonButton, CommonInput } from "../../Input";
import DataTable from "../../table/DataTable";
import IndividualCustomerModal from "../IndividualCustomerModal";
import OrganizationCustomerModal from "../OrganizationCustomerModal";

const Step0SelectCustomer = ({ onSelectCustomer }) => {
  const [showIndividualModal, setShowIndividualModal] = useState(false);
  const [showOrganizationModal, setShowOrganizationModal] = useState(false);

  const [filters, setFilters] = useState({
    name: "",
    idCard: "",
    phone: "",
    email: "",
  });

  const columns = [
    { label: "User ID", key: "id", className: "ps-4" },
    {
      label: "Name",
      key: "name",
      render: (item) => <span className="fw-bold text-black">{item.name}</span>,
    },
    {
      label: "Type",
      key: "type",
      render: (item) => (
        <Badge
          bg={item.type === "Organization" ? "primary" : "light"}
          className={`px-3 py-1 fw-bold border ${item.type === "Individual" ? "text-muted" : "text-white"}`}
          style={{
            fontSize: "10px",
            backgroundColor:
              item.type === "Organization" ? "var(--primary)" : "#f8f9fa",
          }}
        >
          {item.type}
        </Badge>
      ),
    },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "phone" },
    { label: "ID Card Number", key: "idCard" },
    {
      label: "Available balance",
      key: "available",
      render: (item) => (
        <div className="text-end pe-3">
          <div className="fw-bold text-black">{item.available} SGD</div>
          <div className="text-muted fs-11">0 USD</div>
        </div>
      ),
    },
    {
      label: "Pending balance",
      key: "pending",
      render: (item) => (
        <div className="text-end pe-3">
          <div className="fw-bold text-black">{item.pending} SGD</div>
          <div className="text-muted fs-11">0 USD</div>
        </div>
      ),
    },
    {
      label: "Status",
      key: "status",
      render: (item) => (
        <Badge
          bg="success"
          className="bg-opacity-10 text-success px-3 py-1 border border-success border-opacity-25"
          style={{ fontSize: "10px" }}
        >
          {item.status}
        </Badge>
      ),
    },
    {
      label: "KYC Status",
      key: "kyc",
      render: (item) => (
        <Badge
          bg={item.kyc === "APPROVED" ? "success" : "warning"}
          className="bg-opacity-10 px-3 py-1 border border-opacity-25"
          style={{
            fontSize: "10px",
            color: item.kyc === "APPROVED" ? "#34D399" : "#FBBF24",
            borderColor: item.kyc === "APPROVED" ? "#34D399" : "#FBBF24",
          }}
        >
          {item.kyc}
        </Badge>
      ),
    },
    {
      label: "Created Time",
      key: "created",
      render: (item) => (
        <div className="fs-11">
          <div className="text-black">{item.date}</div>
          <div className="text-muted">{item.time}</div>
        </div>
      ),
    },
  ];

  const mockCustomers = [
    {
      id: "10844",
      name: "SparkMinds Technology Pte Ltd",
      type: "Organization",
      email: "checkpast12month@yopmail.com",
      phone: "+84 765161894",
      idCard: "S1234567A013",
      available: "111,612.45",
      pending: "0",
      status: "ACTIVATED",
      kyc: "APPROVED",
      date: "06/03/2026",
      time: "18:23:59",
    },
    {
      id: "10843",
      name: "Thuy Nga Phan",
      type: "Individual",
      email: "checkpast12month@yopmail.com",
      phone: "+84 789908092",
      idCard: "check12month",
      available: "969",
      pending: "7,031.05",
      status: "ACTIVATED",
      kyc: "APPROVED",
      date: "06/03/2026",
      time: "11:38:29",
    },
    {
      id: "10842",
      name: "idjaoida",
      type: "Organization",
      email: "juchuiajhdba@yopmail.com",
      phone: "+65 93213213",
      idCard: "154651651",
      available: "--",
      pending: "--",
      status: "ACTIVATED",
      kyc: "PENDING",
      date: "05/03/2026",
      time: "10:41:31",
    },
  ];

  const handleReset = () => {
    setFilters({ name: "", idCard: "", phone: "", email: "" });
  };

  return (
    <div className="mt-4">
      {/* Filters */}
      <div className="d-flex align-items-center flex-wrap gap-2 mb-4 bg-light p-3 rounded-4 bg-opacity-50">
        <div style={{ width: "160px" }}>
          <CommonInput
            placeholder="Enter name"
            value={filters.name}
            onChange={(e) => setFilters({ ...filters, name: e.target.value })}
          />
        </div>
        <div style={{ width: "160px" }}>
          <CommonInput
            placeholder="Enter ID Card No"
            value={filters.idCard}
            onChange={(e) => setFilters({ ...filters, idCard: e.target.value })}
          />
        </div>
        <div style={{ width: "160px" }}>
          <CommonInput
            placeholder="Enter phone"
            value={filters.phone}
            onChange={(e) => setFilters({ ...filters, phone: e.target.value })}
          />
        </div>
        <div style={{ width: "160px" }}>
          <CommonInput
            placeholder="Enter email"
            value={filters.email}
            onChange={(e) => setFilters({ ...filters, email: e.target.value })}
          />
        </div>
        <CommonButton
          variant="outline"
          onClick={handleReset}
          className="p-0 d-flex align-items-center justify-content-center"
        >
          <i className="flaticon-381-repeat-1"></i>
        </CommonButton>
        <CommonButton className="p-0 d-flex align-items-center justify-content-center">
          <i className="fa fa-search text-white"></i>
        </CommonButton>
      </div>

      {/* Table */}
      <div className="card shadow-none rounded-4 overflow-hidden border border-light mb-4">
        <DataTable
          columns={columns}
          data={mockCustomers}
          showPagination={false}
          minWidth="1400px"
          onRowClick={onSelectCustomer}
          rowClassName={() => "cursor-pointer"}
        />
      </div>

      {/* Footer Buttons */}
      <div className="d-flex justify-content-end gap-3 mt-4">
        <CommonButton
          variant="outline"
          className="d-flex align-items-center gap-2 py-2 px-4 fs-13"
          onClick={() => setShowIndividualModal(true)}
        >
          Create Individual Customer
        </CommonButton>
        <CommonButton
          variant="outline"
          className="d-flex align-items-center gap-2 py-2 px-4 fs-13"
          onClick={() => setShowOrganizationModal(true)}
        >
          Create Organization Customer
        </CommonButton>
      </div>

      <IndividualCustomerModal
        show={showIndividualModal}
        onHide={() => setShowIndividualModal(false)}
      />
      <OrganizationCustomerModal
        show={showOrganizationModal}
        onHide={() => setShowOrganizationModal(false)}
      />
    </div>
  );
};

export default Step0SelectCustomer;
